import { render, staticRenderFns } from "./add-update.vue?vue&type=template&id=4c8bac28&scoped=true&"
import script from "./add-update.vue?vue&type=script&lang=js&"
export * from "./add-update.vue?vue&type=script&lang=js&"
import style0 from "./add-update.vue?vue&type=style&index=0&id=4c8bac28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8bac28",
  null
  
)

export default component.exports